import React, { useState } from 'react';
import { Box, Button, Paper, Stack, Typography, Alert } from '@mui/material';
import { OpenInNew as OpenInNewIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { PageHeader } from '../../components/ui';

/**
 * Страница мониторинга cron-задач (Bull Board UI).
 *
 * Bull Board — это server-rendered страница, отдаваемая основным бэкендом
 * по пути `/api/admin/queues`. Чтобы пробросить JWT-авторизацию,
 * сначала открываем preauth-роут `/api/admin/queues-auth?t=<jwt>` — он
 * валидирует токен, ставит httpOnly cookie `cron_jwt` и редиректит на UI.
 */
export default function CronMonitor() {
  const { token } = useSelector((state) => state.auth);
  const [iframeKey, setIframeKey] = useState(0);

  const preauthUrl = token
    ? `/api/admin/queues-auth?t=${encodeURIComponent(token)}`
    : null;

  const openInNewTab = () => {
    if (!preauthUrl) return;
    window.open(preauthUrl, '_blank', 'noopener');
  };

  const reloadIframe = () => setIframeKey((k) => k + 1);

  return (
    <Box sx={{ pb: 4 }}>
      <PageHeader
        title="Cron-задачи"
        subtitle="Управление и мониторинг очередей BullMQ. История прогонов, ручной запуск, ретраи."
        breadcrumbs={[
          { label: 'Главная', path: '/' },
          { label: 'Настройки' },
          { label: 'Cron-задачи' },
        ]}
        actions={
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={reloadIframe}
              disabled={!token}
            >
              Перезагрузить
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<OpenInNewIcon />}
              onClick={openInNewTab}
              disabled={!token}
            >
              Открыть в новой вкладке
            </Button>
          </Stack>
        }
      />

      {!token && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Нет токена авторизации. Перелогиньтесь.
        </Alert>
      )}

      <Paper
        elevation={0}
        sx={{
          border: (theme) => `1px solid ${theme.palette.outlineVariant}`,
          borderRadius: 2,
          overflow: 'hidden',
          height: 'calc(100vh - 220px)',
          minHeight: 600,
        }}
      >
        {preauthUrl ? (
          <iframe
            key={iframeKey}
            src={preauthUrl}
            title="Bull Board"
            style={{ border: 0, width: '100%', height: '100%', display: 'block' }}
          />
        ) : (
          <Box sx={{ p: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Bull Board недоступен без активного токена.
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
}
